import {
    validateEmail,
    validateFirstName,
    validateLastName,
    validateDay,
    validateMonth,
    validateYear
} from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validateEmail(values),
        ...validateDay(values),
        ...validateMonth(values),
        ...validateYear(values)
    };
    return errors;
};

export default validate;
